/*
 * @Author: shannyHuang
 * @Date: 2022-03-28 21:41:47
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-08-15 00:19:55
 * @FilePath: /wemeet-web-activity/src/utils/ua/is-mobile.ts
 */
import { isSafari } from './is-safari';

export const isMobile = () => {
  if (isSafari(navigator.userAgent) && navigator.maxTouchPoints) {
    // some iPads just does not have `iPad` in UA
    return true;
  }
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

// warn: iPad 13.5 系统会判断为false
export const isMobileServer = (ua: string) =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
export const isMeetingAppServer = (ua: string) => /app\/tencent_wemeet/i.test(ua);
export const isMeetingApp = () => !!navigator.userAgent.match(/app\/tencent_wemeet/);
